import Oidc from "oidc-client";

// console.log(process.env.SCOPES);

var mgr = new Oidc.UserManager({
    authority: process.env.OIDC,
    client_id: process.env.CLIENT,
    redirect_uri: process.env.OIDC + "/Callback",
    response_type: "code",
    scope: process.env.SCOPES,
    post_logout_redirect_uri: process.env.OIDC,
    automaticSilentRenew: true,
    silent_redirect_uri: process.env.OIDC + "/Account/SilentRenew",
    accessTokenExpiringNotificationTime: 10,
    userStore: new Oidc.WebStorageStateStore({
        store: window.localStorage
    })
});

// Oidc.Log.logger = console;
// Oidc.Log.level = Oidc.Log.INFO;

export default mgr;


// WEBPACK FOOTER //
// ./App/security.js